import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { reviewColumns, routes } from '../../constants';
import { Award, Building2, CircleCheck, CircleX, Contact, Landmark, Notebook, Users, ChevronRight, Plus, X } from 'lucide-react';
import { Box, Button, Card, CardContent, CardHeader, CardTitle, SectionTitle, Tag, Table, Typography } from '@otcmarketsgroup/otcm-ui-lib';

const ReviewSection = ({ identifier, data, isVerified, name, symbol, path }) => {
  const sectionData = data && data[identifier] ? data[identifier] : [];
  const addNewColumns = reviewColumns.filter(col => col.id !== 'oldValue');

  const titleIconMap = {
    companyInfo: <Building2 />,
    contactInfo: <Notebook />,
    people: <Users />,
    serviceProviders: <Landmark />,
    designatedContacts: <Contact />,
    securities: <Award />
  };

  const sectionIcon = titleIconMap[identifier];

  return <Card key={identifier} hasBorder>
    <CardHeader>
      <Box display='flex' alignItems='center' gap={2}>
        <CardTitle icon={sectionIcon}>{name}</CardTitle>
        <Tag
          label={isVerified ? 'Verified' : 'Not Verified'}
          size="small"
          color={isVerified ? 'success' : 'warning'}
          icon={isVerified ? <CircleCheck size={14} color='var(--otc-white)' /> : <CircleX size={14} color='var(--otc-white)' />}
        />
      </Box>
      <Link to={`${routes.PROFILE_PREFIX}/${symbol}/${path}`}>
        <Button variant='text' endIcon={<ChevronRight strokeWidth={2.5} size={14} />}>View/Edit</Button>
      </Link>
    </CardHeader>
    <CardContent>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {sectionData && sectionData.length > 0 && sectionData.map((section, i) => <Box key={`${section.header}-${i}`}>
          <SectionTitle
            noUnderline={!section.isDeleted}
            icon={section.isNew ? <Plus color='var(--otc-green)' /> : section.isDeleted ? <X color='var(--otc-warning)' /> : null}>
            {section.header}
          </SectionTitle>
          {(section.fields && section.fields.length > 0) && <Table
            columns={section.isNew ? addNewColumns : reviewColumns}
            data={section.fields}
            size='small'
            bandedRows
          />}
        </Box>)}
        {!sectionData || sectionData.length === 0 && <Typography variant="body1" color={isVerified ? "primary" : "warning"}>{isVerified ? 'Verified - no changes were made.' : 'Not Verified - no changes were made.'}</Typography>}
      </Box>
    </CardContent>
  </Card>;
};

ReviewSection.propTypes = {
  identifier: PropTypes.string,
  isVerified: PropTypes.bool,
  name: PropTypes.string,
  path: PropTypes.string,
  symbol: PropTypes.string,
  data: PropTypes.object
};

export default ReviewSection;
